import { formatDate } from "../utils";
import TokenResource from "./TokenResource";
export interface IAttachment {
	id: number;
	name: string;
}

export type MessageModel = {
	id: string;
	title: string;
	messageBody: string;
	objectCar: string;
	receivedDate: Date;
	receivedDateDisplay: string;
	messageType: string;
	opened: boolean;
	attachments: IAttachment[];
}

export default class MessageResource extends TokenResource {
	id = "";
	title = "";
	messageBody = "";
	objectCar = "";
	receivedDate = "";
	messageType = "";
	opened = false;
	attachments: IAttachment[] = [];

	pk() {
		return this.id.toString();
	}

	toClientModel = (): MessageModel => ({
		attachments: this.attachments,
		id: this.id,
		messageBody: this.messageBody,
		messageType: this.messageType,
		objectCar: this.objectCar,
		opened: this.opened,
		receivedDateDisplay: formatDate(this.receivedDate),
		receivedDate: new Date(this.receivedDate),
		title: this.title
	});

	static fromClientModel = (x: MessageModel): MessageResource => ({
		attachments: x.attachments,
		id: x.id,
		messageBody: x.messageBody,
		messageType: x.messageType,
		objectCar: x.objectCar,
		opened: x.opened,
		recievedDate: x.receivedDate,
		title: x.title
	} as unknown) as MessageResource;

	static urlRoot = "/api/messages";
}
